import * as Yup from "yup";

const alterarSenhaValidator = Yup.object().shape({
  novaSenha: Yup.string().required("Nova senha"),
  confirmarNovaSenha: Yup.string().required("Confirmar senha"),
});

export default alterarSenhaValidator;
